import CustomPalette from '@/theme/CustomPalette'

export const COMPANY_COLUMN_WIDTH = 376

export const tableWrapperStyles = {}

export const tableContainerStyles = {
  overflowX: 'auto' as const,
}

export const tableStyles = {
  tableLayout: 'fixed' as const,
  '& td, & th': { borderBottom: 'none', position: 'relative' },
  '& td::after, & th::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '1px',
    backgroundColor: CustomPalette.Air,
  },
  '& td:first-of-type::after, & th:first-of-type::after': { left: '25px' },
  '& td:last-of-type::after, & th:last-of-type::after': { right: '25px' },
  '& thead tr th::after': { display: 'none' },
  '& tbody tr:last-child td::after': { display: 'none' },
}

export const tableHeadStyles = {
  backgroundColor: '#f8f8fa',
  borderBottom: '0px solid',
}

export const headerCellStyles = {
  height: '40px',
  py: 0,
  pl: '56px',
  minWidth: 336,
  maxWidth: 376,
}

export const setupHeaderCellStyles = {
  height: '40px',
  py: 0,
}

export const paginationStackStyles = {
  px: 2,
  py: 1.5,
}

export const filterBarStyles = {
  px: 3,
  pb: 2,
}

export const filterToggleGroupStyles = {
  gap: 1,
  '& .MuiToggleButtonGroup-grouped': {
    border: `1px solid ${CustomPalette.Air}`,
    borderRadius: '20px',
    px: 2,
    py: 0.5,
    lineHeight: '24px',
    textTransform: 'none' as const,
    '&:not(:first-of-type)': {
      borderLeft: `1px solid ${CustomPalette.Air}`,
      borderRadius: '20px',
      ml: 0,
    },
    '&:first-of-type': {
      borderRadius: '20px',
    },
  },
}
